<template>
  <div class="vip-tip" @click="handleOpenVip">{{ $t('detailPage.vip.episodes.tip1') }}</div>
</template>
<script>
export default {
  name: 'VipTip',
  methods: {
    handleOpenVip() {
      this.$emit('getDownloadLink', true)
    }
  }
}
</script>
<style scoped lang="scss">
.vip-tip {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 150%;
  color: #975c25;

  background: linear-gradient(92.59deg, #f2c4a8 0%, #edd2c2 100%);
  border-radius: 8px;
  padding: 16px 20px;
  box-sizing: border-box;
  margin: 0 20px 20px;
  cursor: pointer;
}
</style>
